import React, {
    Component,
    createElement,
    Fragment,
    CSSProperties,
    useState
} from "react";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ReactPaginate from "react-paginate";
import Select, { AriaOnFocus } from "react-select";
import "whatwg-fetch";
import BaseGrid from "./BaseGrid";
import BulletboardItem from "./BulletboardItem";
import Loader from "./Loader";
import NoResults from "./NoResults";

const abortableFetch = "signal" in new Request("") ? window.fetch : fetch;
let fetchController;

const debounce = (fn, delay) => {
    let timer = null;
    return function(...args) {
        const context = this;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};

class BulletboardArchive extends Component {
    constructor(props) {
        super(props);

        this.listRef = React.createRef();

        this.state = {
            cities: [],
            items: [],
            vogMessage: window.pp_bulletboard_vars.vogMessage,
            successMessage: null,
            errorMessage: null,
            targetAudience: window.pp_bulletboard_vars.targetAudience,
            cities: window.pp_bulletboard_vars.cities,
            recaptchaKey: window.pp_bulletboard_vars.recaptchaKey,
            addNewItemNonce: window.pp_bulletboard_vars.addNewItemNonce,
            addNewResponseNonce: window.pp_bulletboard_vars.addNewResponseNonce,
            archivePageUrl: window.pp_bulletboard_vars.archivePageUrl,
            currentPage: 1,
            filter_city: null,
            filter_target_audience: null,
            showScrollToTopButton: false
        };
    }

    componentDidMount() {
        this.retriveCities();
        this.retriveTargetAudiences();
        this.retriveSettings();
        this.retrieveItems();

        window.addEventListener(
            "scroll",
            debounce(this.toggleScrollToTopButton.bind(this), 20)
        );
    }

    retriveCities() {
        return window.pp_bulletboard_vars.cities;
    }

    retriveTargetAudiences() {
        return window.pp_bulletboard_vars.target_audience;
    }

    retriveSettings() {
        return window.pp_bulletboard_vars;
    }

    retriveData(url, stateKey) {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(data =>
                    this.setState({ [stateKey]: data }, () => {
                        resolve();
                    })
                );
        });
    }

    componentWillUnmount() {
        window.removeEventListener(
            "scroll",
            debounce(this.toggleScrollToTopButton.bind(this), 20)
        );
    }

    retrieveItems() {
        if (this.state.loading) {
            fetchController.abort();
        }

        fetchController = new AbortController();

        this.setState({ loading: true });

        let pageSize = 10;
        if (this.state.view === "map") {
            pageSize = 100;
        }

        const JSON_API_URL = `/wp-json/wp/v2/pp_bulletboard_item?`;

        const params = {
            status: "publish",
            per_page: pageSize,
            page: this.state.currentPage
        };

        if (this.state.filter_city !== null) {
            params.bulletboard_city = this.state.filter_city;
        }

        if (this.state.filter_target_audience !== null) {
            params.bulletboard_target_audience = this.state.filter_target_audience;
        }

        const serialize = obj => {
            return Object.entries(obj)
                .filter(([, value]) => value)
                .map(([key, value]) => {
                    if (typeof value === "object") {
                        return Object.entries(value).map(
                            ([subkey, value]) =>
                                `${key}[${subkey}]=${encodeURIComponent(value)}`
                        );
                    } else {
                        return `${key}=${encodeURIComponent(value)}`;
                    }
                })
                .join("&");
        };

        let url = `${JSON_API_URL}?${serialize(params)}`;

        abortableFetch(url, {
            signal: fetchController.signal
        })
            .then(response => {
                this.setState({
                    total: parseInt(response.headers.get("x-wp-total"), 10),
                    totalPages: parseInt(
                        response.headers.get("x-wp-totalpages"),
                        10
                    )
                });

                return response.json();
            })
            .then(data => {
                this.setState({ items: data, loading: false });
            });
    }

    handleChangePage(pageObject) {
        this.setState(
            {
                currentPage: pageObject.selected + 1
            },
            () => this.retrieveItems()
        );
    }

    scrollToTop() {
        this.listRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }

    toggleScrollToTopButton() {
        const showButton = window.scrollY > 550;

        if (showButton) {
            this.setState({ showScrollToTopButton: true });
        } else {
            this.setState({ showScrollToTopButton: false });
        }
    }

    renderTargetAudienceOptions() {
        const options = [
            {
                value: null,
                label: "Alle doelgroepen"
            }
        ];

        return [
            ...options,
            ...this.state.targetAudience.map(option => {
                return {
                    value: option.term_id,
                    label: option.name
                };
            })
        ];
    }

    renderCitiesOptions() {
        const options = [
            {
                value: null,
                label: "Alle plaatsen"
            }
        ];

        return [
            ...options,
            ...this.state.cities.map(option => {
                return {
                    value: option.term_id,
                    label: option.name
                };
            })
        ];
    }

    renderGrid() {
        return (
            <Fragment>
                <div className="bulletboard__filters">
                    <form>
                        <label
                            id="place"
                            htmlFor="place-input"
                            className="bulletboard__filters__label"
                        >
                            Selecteer een plaats
                        </label>

                        <Select
                            options={this.renderCitiesOptions()}
                            classNamePrefix="select"
                            placeholder="Filter op plaats"
                            aria-labelledby="place"
                            inputId="place-input"
                            name="aria-live-place"
                            isSearchable={false}
                            onChange={option => {
                                this.setState(
                                    {
                                        filter_city: option
                                            ? option.value
                                            : null
                                    },
                                    () => {
                                        this.retrieveItems();
                                    }
                                );
                            }}
                        />
                    </form>
                    <form>
                        <label
                            id="target-audience"
                            className="bulletboard__filters__label"
                            htmlFor="target-audience-input"
                        >
                            Selecteer een doelgroep
                        </label>
                        <Select
                            options={this.renderTargetAudienceOptions()}
                            classNamePrefix="select"
                            aria-labelledby="target-audience"
                            placeholder="Filter op doelgroep"
                            inputId="target-audience-input"
                            name="aria-live-target"
                            isSearchable={false}
                            onChange={option =>
                                this.setState(
                                    {
                                        filter_target_audience: option
                                            ? option.value
                                            : null
                                    },
                                    () => {
                                        this.retrieveItems();
                                    }
                                )
                            }
                        />
                    </form>
                </div>
                <div className="section section--list" ref={this.listRef}>
                    <BaseGrid loading={this.state.loading}>
                        {this.state.items.length > 0 ? (
                            this.state.items.map(organization => {
                                return (
                                    <BulletboardItem
                                        settings={this.state.settings}
                                        addNewResponseNonce={
                                            this.state.addNewResponseNonce
                                        }
                                        recaptchaKey={this.state.recaptchaKey}
                                        vogMessage={this.state.vogMessage}
                                        item={organization}
                                        key={organization.id}
                                    />
                                );
                            })
                        ) : this.state.loading ? (
                            <Loader loadingText="Items worden geladen..." />
                        ) : (
                            <NoResults />
                        )}
                    </BaseGrid>

                    {this.state.showScrollToTopButton &&
                    this.state.items.length ? (
                        <div className="buttons back-to-top">
                            <button
                                className="button small button--secondary button--sticky button--hide-if-not-sticky"
                                onClick={e => this.scrollToTop()}
                            >
                                Terug naar boven
                            </button>
                        </div>
                    ) : null}
                    {this.state.items.length > 0 ? (
                        <nav className="pagination" aria-label="Meer advertenties" aria-roledescription="paginering">
                            <ReactPaginate
                                containerClassName="pagination__items"
                                pageClassName="pagination__item"
                                breakClassName="pagination__item"
                                activeClassName="pagination__item--active"
                                nextClassName="pagination__item--next"
                                previousClassName="pagination__item--prev"
                                pageCount={this.state.totalPages}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                previousLabel="Vorige"
                                nextLabel="Volgende"
                                breakLabel="..."
                                onPageChange={this.handleChangePage.bind(this)}
                            />
                        </nav>
                    ) : null}
                </div>
            </Fragment>
        );
    }

    getWrapperClass() {
        const loadingCLass = this.state.loading ? "loading" : "";

        return `bulletboard__content ${loadingCLass}`;
    }

    render() {
        if (this.state.settings === null) {
            return null;
        }

        if (window.pp_bulletboard_vars.recaptchaKey === "") {
            return (
                <div className="message">Stel een google recaptcha key in!</div>
            );
        }

        return (
            <GoogleReCaptchaProvider
                reCaptchaKey={window.pp_bulletboard_vars.recaptchaKey}
                container={{
                    element: "recaptcha__wrap",
                    parameters: {
                        badge: 'inline',
                    }
                }}
            >
                <div className={this.getWrapperClass()}>
                    {this.renderGrid()}
                </div>
            </GoogleReCaptchaProvider>
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    let el = document.querySelector(".bulletboard__archive");
    if (el === null) {
        return;
    }

    ReactDOM.render(createElement(BulletboardArchive, el.dataset), el);
});
